// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"_20ZLi","list":"_3sDDZ","listHeader":"hmxte","listText":"_38YEe","seeAllList":"_bthV"};